import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
    providedIn: 'root'
})
export class ContactFieldService {

    baseUrl = environment.contactURL;
    constructor(private http: HttpClient) { }

    addTags(tag) {
        return this.http.post<any>(this.baseUrl + 'Tag', tag);
    }

    getAllTags() {
        return this.http.get<any>(`${this.baseUrl}Tag`);
    }

    editTags(tag) {
        return this.http.put<any>(this.baseUrl + 'Tag', tag);
    }

    deleteTags(id) {
        return this.http.delete<any>(this.baseUrl + `Tag/${id}`);
    }

    // Add your service methods here

}